import { derived } from "svelte/store"
import { useQuery } from "@sveltestack/svelte-query";

export function useOnlineLicenseAuthenticationResult() {
  const query = useQuery("/api/license/online")
  return derived(query, query => query.data)
}
